import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { GUIDE_CONFIG } from './base/guide-configs';

/**
 * 가이드 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * GUIDE_CONFIG.routePath 경로로 등록.
 */
export const guideRoutes: Routes = [
  {
    path: GUIDE_CONFIG.routePath,
    canActivate: [permissionGuard('GUIDE_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/guide-list-page/guide-list-page.component'
          ).then((m) => m.GuideListPageComponent),
        data: {
          config: GUIDE_CONFIG,
          title: '가이드',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/guide-detail-page/guide-detail-page.component'
              ).then((m) => m.GuideDetailPageComponent),
            data: {
              config: GUIDE_CONFIG,
              title: '가이드 상세',
            },
          },
        ],
      },
    ],
  },
];
